import {
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  Flex,
  Box,
  InputGroup,
  InputLeftElement,
  ModalCloseButton,
  Input,
} from '@chakra-ui/react';
import { debounce, isEqual } from 'lodash-es';
import SearchIcon from '@/icons/Search';
import { useEffect, useState, useRef } from 'react';
import { fetchCandidateTouchpointDrilldown } from '@/store/reports/flow-health/candidate-touchpoint/actions';
import { useDispatch, useSelector } from 'react-redux';
import { Loading } from '../../../../shared/loading';
import {
  selectDrilldownData,
  selectDrilldownDataIsLoading,
} from '@/store/reports/flow-health/candidate-touchpoint/selectors';
import { ActivitiesTable } from '../../../../shared/activity-popup/activity-table';
import { drilldownContent } from '@/pages/reports/non-ats-reports/shared/activity-popup/drilldown-content';

export const ActivityPopup = ({
  isOpen = true,
  onClose = () => {},
  filters = {},
  selected = {},
  filterParams = undefined,
}) => {
  const [search, setSearch] = useState(null);
  const dispatch = useDispatch();
  const isLoading = useSelector(selectDrilldownDataIsLoading);
  const drilldownData = useSelector(selectDrilldownData);
  const [searchDate, setSearchData] = useState(null);
  const initialLoadDone = useRef(false);
  const prevParamsRef = useRef(null);

  const OnSearch = debounce((event) => {
    setSearch(event?.target?.value);
    const result = drilldownData?.filter((data) => {
      return (
        data?.contact?.first_name
          ?.toLowerCase()
          ?.includes(event?.target?.value?.toLowerCase()) ||
        data?.contact?.last_name
          ?.toLowerCase()
          ?.includes(event?.target?.value?.toLowerCase())
      );
    });
    setSearchData(result);
  }, 300);

  useEffect(() => {
    if (!isOpen || !filters || !selected) return;

    const currentParams = { filters, selected, filterParams };

    // First load or parameters changed
    if (
      !prevParamsRef.current ||
      !isEqual(prevParamsRef.current, currentParams)
    ) {
      const apiParams = { filters, selected };
      if (filterParams !== undefined) {
        apiParams.filterParams = filterParams;
      }
      dispatch(fetchCandidateTouchpointDrilldown(apiParams));
      prevParamsRef.current = currentParams;
      initialLoadDone.current = true;
    }
  }, [isOpen, filters, selected, filterParams, dispatch]);

  const renderContent = () => {
    if (isLoading && !initialLoadDone.current) {
      return (
        <Box height="350px">
          <Loading />
        </Box>
      );
    }

    return (
      <Box p="24px">
        <Text fontSize="24px" fontWeight="semiBold">
          {drilldownContent?.[selected?.id]?.title}
        </Text>
        <Flex alignItems="baseline">
          <Text color="rgba(22, 22, 22, 0.50)">
            {drilldownContent?.[selected?.id]?.description}
          </Text>
          <Box ml="auto">
            <InputGroup>
              <InputLeftElement
                pointerEvents="none"
                children={<SearchIcon />}
              />
              <Input placeholder="Search" onChange={OnSearch} />
            </InputGroup>
          </Box>
        </Flex>
        <Box mt="12px">
          <ActivitiesTable
            data={search ? searchDate : drilldownData}
            content={drilldownContent}
          />
        </Box>
      </Box>
    );
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="5xl" isCentered p="0">
      <ModalOverlay />
      <ModalContent h="500px">
        <ModalCloseButton />
        <ModalBody p="0">{renderContent()}</ModalBody>
      </ModalContent>
    </Modal>
  );
};
